import React, { forwardRef } from "react";
import MaterialTableOrig, { MaterialTableProps } from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import FilterListIcon from "@material-ui/icons/FilterList";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import DeleteIcon from "@material-ui/icons/Delete";
import AddBoxIcon from '@material-ui/icons/AddBox';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import ReplayIcon from '@material-ui/icons/Replay';

export const MaterialTable = <RowData extends object>(props: MaterialTableProps<RowData>) => {
    return (
        <MaterialTableOrig
            icons={{
                Edit: forwardRef((p, ref) => <EditIcon {...p} ref={ref} />),
                Filter: forwardRef((p, ref) => <FilterListIcon {...p} ref={ref} />),
                Check: forwardRef((p, ref) => <CheckIcon {...p} ref={ref} />),
                Clear: forwardRef((p, ref) => <ClearIcon {...p} ref={ref} />),
                Search: forwardRef((p, ref) => <SearchIcon {...p} ref={ref} />),
                ResetSearch: forwardRef((p, ref) => <ClearIcon {...p} ref={ref} />),
                FirstPage: forwardRef((p, ref) => <FirstPageIcon {...p} ref={ref} />),
                LastPage: forwardRef((p, ref) => <LastPageIcon {...p} ref={ref} />),
                NextPage: forwardRef((p, ref) => <ChevronRightIcon {...p} ref={ref} />),
                PreviousPage: forwardRef((p, ref) => <ChevronLeftIcon {...p} ref={ref} />),
                SortArrow: forwardRef((p, ref) => <ArrowUpwardIcon {...p} ref={ref} />),
                Delete: forwardRef((p, ref) => <DeleteIcon {...p} ref={ref} />),
                Add: forwardRef((p, ref) => <AddBoxIcon {...p} ref={ref} />),
                DetailPanel: forwardRef((p, ref) => <ChevronRightIcon {...p} ref={ref} />),
                Export: forwardRef((p, ref) => <GetAppOutlinedIcon {...p} ref={ref} />),
                Retry: forwardRef((p, ref) => <ReplayIcon {...p} ref={ref} />),
            }}
            {...props}
        />
    );
};
